import axios from '@/assets/js/axiosExtend';
import Tool from '@/assets/js/common/utils';
const baseUrl = '/filebackend';
const uServiceUrl = '/userAuth'
const session = Tool.getCookie();
import { apiUrl } from '@/assets/js/config';
import ajax from 'axios';
import { gatewayUrl } from '@/assets/js/config';

// 获取用户信息
export async function getUserInfo() {
  console.log(session);
  const url = baseUrl + '/user/getLoginUser?session=' + session;
  const res = await axios.get(url);
  return res;
}

// 获取文件夹内容
export function getSessionInfo(param) {
  const url = `${baseUrl}/record/getSessionInfo?pageSize=${param.pageSize}&pageNum=${param.pageNum}&searchparam=${param.searchparam}`;
  const res = axios.get(url);
  return res;
}

// 获取record信息
export function getSessionChild(data) {
  // const url = `${baseUrl}/record/v2/getSources?recordSessionId=${data.id}`;
  // const res = axios.get(url);
  // return res;

  const params = { sessionTitle: data.title, recordSessionId: data.id };
  const url = `${baseUrl}/record/v3/getSources`;

  const res = axios.post(url, params);
  return res;
}

// 获取source里文件的信息
export function getRecordTaskInfo(data) {
  const url = `${baseUrl}/record/v2/getTaskInfo?recordSessionId=${data.session}&sourceId=${data.id}`;
  const res = axios.get(url);
  return res;
}

// 发送下载请求
export function confirmToDownload(param) {
  const url = `${baseUrl}/record/createDownloadTask`;
  const res = axios.post(url, param);
  return res;
}

// 发送下载请求
export function getRecordChrild(param) {
  const url = `${baseUrl}/record/createDownloadTask`;
  const res = axios.post(url, param);
  return res;
}

// 发送删除请求
export function deleteVideo(param) {
  console.log(param, 'param')
  // return false;
  // https://gateway-test.tvunetworks.com/drive-api/file/delete
  // /drive-api/file/batchDelete`;
  const url = `${gatewayUrl}/drive-api/file/delete`;
  // const url = `${baseUrl}/record/delete`;
  const res = axios.post(url, { id:param });
  // delete的时候params和body里都能传参，在params里的话，就和get一样，像这样{params}，在body里的时候，要再包一层，像这样{data：params}就ok了
  return res;
}
// Bulk delete
export function deleteVideoBulk(param) {
  // console.log(param, 'param')
  // return false;
  // https://gateway-test.tvunetworks.com/drive-api/file/delete
  // /drive-api/file/batchDelete`;
  const url = `${gatewayUrl}/drive-api/file/skippableDelete`;
  // const url = `${gatewayUrl}/drive-api/file/batchDelete`;
  // const url = `${baseUrl}/record/delete`;
  const res = axios.post(url, { idList: param });
  // delete的时候params和body里都能传参，在params里的话，就和get一样，像这样{params}，在body里的时候，要再包一层，像这样{data：params}就ok了
  return res;
}

// updateShortUrl
export function updateShortUrl(param) {
  const url = `${gatewayUrl}/newppapi/nyt/updateShortUrl`;
  const res = axios.post(url, param);
  return res;
}

// get all marker list
export function getMarkerFileList(param) {
  let url = new URL(`${apiUrl}/marker`);

  if (param && Object.keys(param).length > 0) {
    Object.keys(param).forEach((key) =>
      url.searchParams.append(key, param[key])
    );
  }

  return fetch(url)
    .then((res) => res.json())
    .then((response) => {
      if (
        response.errorCode === '0x0' &&
        response.markerinfo &&
        response.markerinfo.length > 0
      ) {
        response['markerinfo'].forEach((marker, index) => {
          response['markerinfo'][index].isMarker = true;

          response['markerinfo'][index].downloadMarkerSourceId =
            param.sourceid + '_0';

          response['markerinfo'][index].startTimeStamp = marker.starttimestamp;

          response['markerinfo'][index].endTimeStamp =
            parseInt(marker.endtimestamp) > 0
              ? marker.endtimestamp
              : Date.now();
        });

        return response;
      } else {
        return null;
      }
    });
}
// Delete
export function deleteMarkerVideo(param) {
  const url = `${apiUrl}/marker`;
  const formData = new FormData();
  formData.append('markerid', param);

  return fetch(url, {
    method: 'delete',
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => data);

  //const res = axios.delete(url, { data: param });
  // delete的时候params和body里都能传参，在params里的话，就和get一样，像这样{params}，在body里的时候，要再包一层，像这样{data：params}就ok了
  //return res;
}

// Load remote recording service listing
// export function loadRemoteRecordSessionInfo(param) {
//   const url = `${baseUrl}/remote_recording/querySession`;
//   const res = axios.post(url, param);
//   return res;
// }
export function loadRemoteRecordDriveId() {
  const url = `${gatewayUrl}/drive-api/drive/default`;
  const res = axios.get(url);
  return res;
}

export function loadRemoteRecordIframeClipDetails(param) {
  const url = `${gatewayUrl}/drive-api/file/all-metadata/${param}`;
  const res = axios.get(url);
  return res;
}
export function loadRemoteRecordSessionInfo(param) {
  const url = `${gatewayUrl}/drive-api/file/sub-files-by-parent-objectkey`;
  const res = axios.post(url, param);
  return res;
}
export function loadRemoteRecordSessionInfoPagination(param) {
  const url = `${gatewayUrl}/drive-api/file/querySubFiles`;
  const res = axios.post(url, param);
  return res;
}
// export function loadRemoteRecordSessionChildInfo({ productionId }) {
//   const url = `${baseUrl}/remote_recording/getSourcesByProductId`;

//   const res = axios.post(url, { productionId });
//   return res;
// }

export function loadRemoteRecordSessionChildInfo(params) {
  // const url = `${gatewayUrl}/drive-api/file/sub-files-by-parent-objectkey2`;
  const url = `${gatewayUrl}/drive-api/file/querySubFiles`;
  
  const res = axios.post(url, params);
  return res;
}
// export function loadRemoteRecordTaskInfo(param) {
//   const url = `${baseUrl}/remote_recording/listRecordings`;

//   const res = axios.post(url, param);
//   return res;
// }

export function loadRemoteRecordTaskInfo(params) {
  const url = `${gatewayUrl}/drive-api/file/sub-files-by-parent-objectkey`;
  const res = axios.post(url, params);
  return res;
}
export function loadRemoteRecordMarkerInfo(param) {
  const url = `${baseUrl}/remote_recording/list-markers`;

  const res = axios.post(url, param);
  return res;
}
// download for remote recording service
export function confirmRemoteRecordingServiceToDownload(param) {
  const url = `${baseUrl}/remote_recording/createDownloadTask`;
  const res = axios.post(url, param);
  return res;
}

export function addClipFile(params) {
  //const params = { sessionTitle: data.title, recordSessionId: data.id };
  const url = `${gatewayUrl}/drive-api/file/add-file`;

  const res = axios.post(url, params);
  return res;
}

export function getClipFiles(params) {
  //const params = { sessionTitle: data.title, recordSessionId: data.id };
  const url = `${gatewayUrl}/drive-api/file/sub-files-by-parent-objectkey`;

  const res = axios.post(url, params);
  return res;
}
export function loadClippingFileMetaData(url) {
  if (!url) return false;
  //const url = `${gatewayUrl}/drive-api/file/all-metadata/${field}`;
  const res = axios.get(url);
  return res;
}
// =====================
// Load remote recording service listing
export function waffleMenu(sessionID) {
  if (!sessionID) return false;
  //const url = `${gatewayUrl}/drive-api/file/all-metadata/${field}`;
  const url = `https://userservice.tvunetworks.com/userAuth/main/listBoxServices?session=${sessionID}`;
  // const url = `${uServiceUrl}/main/listBoxServices?session=${sessionID}`;
  const res = axios.get(url);
  return res;
}
export function userInfoForWaffleMenu(sessionID) {
  if (!sessionID) return false;
  //const url = `${gatewayUrl}/drive-api/file/all-metadata/${field}`;
  const url = `https://userservice.tvunetworks.com/userAuth/main/getUserInfoBySession?session=${sessionID}`;
  // const url = `${uServiceUrl}main/getUserInfoBySession?session=${sessionID}`;
  const res = axios.get(url);
  return res;
}
export function loadRemoteRecordSessionInfoRRS(params) {
  const url = `${gatewayUrl}/drive-api/file/sub-files-by-parent-objectkey`;
  const res = axios.post(url, params);
  return res;
}
